import { Component, OnInit, Inject, NgZone, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { EpaycoInterfaceForm } from 'src/core/epayco/epayco.types';
import { v4 as uuidv4 } from 'uuid';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-epayco-payment',
  templateUrl: './epayco-payment.component.html',
  styleUrls: ['./epayco-payment.component.css']
})
export class EpaycoPaymentComponent implements OnInit {
  private ePaycoLoaded = false;
  epaycoFormData: EpaycoInterfaceForm;
  private sessionId: string | null = null;
  
  constructor(private ngZone: NgZone, 
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: { epaycoForm: EpaycoInterfaceForm }
  ) { 
    this.epaycoFormData = data.epaycoForm;
  }
  
  private extra3 = "Pet24App";
  private confirmationEnvironment = environment.confirmation;
  private responseEnvironment = environment.response;
  private epaycoTestEnvironment = environment.epaycoTest;
  private epaycoSessionEndpoint = environment.epaycoSessionEndpoint;
  
  // Constantes para evitar valores mágicos
  private readonly CURRENCY = 'cop';
  private readonly COUNTRY = 'co';
  private readonly LANGUAGE = 'en';
  private readonly EXTERNAL = 'true';
  private readonly TYPE_DOC_BILLING = 'cc';
  private readonly DEFAULT_CITA_ID = '0';
  private readonly DEFAULT_EMPTY = '';
  
  esTestEpayco = this.epaycoTestEnvironment;

  ngOnInit() {
    this.loadEPaycoScript();
    console.log('Valor recibido de epaycoFormData:', this.epaycoFormData);
  }
  
  factura(){
    const uniqueId = uuidv4();
    console.log(uniqueId);
    return uniqueId;
  }

  loadEPaycoScript() {
    console.log('Valor recibido de epaycoFormData:', this.epaycoFormData);
    if (!(window as any).ePayco) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://checkout.epayco.co/checkout-v2.js';
      script.async = true;
      script.onload = () => {
        this.ngZone.run(() => {
          this.ePaycoLoaded = true;
          this.initializeEPayco();
        });
      };
      document.body.appendChild(script);
    } else {
      this.ePaycoLoaded = true;
      this.initializeEPayco();
    }
  }

  obtenerSessionId(): Promise<string> {
    return new Promise((resolve, reject) => {
      const request = {
        // DATOS BÁSICOS DE SESIÓN
        citaId: parseInt(this.epaycoFormData.extra1 ?? this.DEFAULT_CITA_ID, 10),
        monto: parseFloat(this.epaycoFormData.amount ?? this.DEFAULT_EMPTY),
        correo: this.epaycoFormData.email_billing ?? this.DEFAULT_EMPTY,
        descripcion: this.epaycoFormData.description ?? this.DEFAULT_EMPTY,
        
        // NOTIFICACIÓN - CRÍTICO
        confirmation: this.confirmationEnvironment,
        response: this.responseEnvironment,
        
        // DATOS DE PAGO
        name: this.epaycoFormData.name ?? this.DEFAULT_EMPTY,
        invoice: this.factura(),
        currency: this.CURRENCY,
        country: this.COUNTRY,
        lang: this.LANGUAGE,
        external: this.EXTERNAL,
        
        // EXTRAS
        extra1: this.epaycoFormData.extra1 ?? this.DEFAULT_EMPTY,
        extra2: this.epaycoFormData.extra2 ?? this.DEFAULT_EMPTY,
        extra3: this.extra3,
        
        // DATOS DE FACTURACIÓN
        name_billing: this.epaycoFormData.name_billing ?? this.DEFAULT_EMPTY,
        address_billing: this.epaycoFormData.address_billing ?? this.DEFAULT_EMPTY,
        type_doc_billing: this.TYPE_DOC_BILLING,
        mobilephone_billing: this.epaycoFormData.mobilephone_billing ?? this.DEFAULT_EMPTY,
        number_doc_billing: this.epaycoFormData.number_doc_billing ?? this.DEFAULT_EMPTY,
        email_billing: this.epaycoFormData.email_billing ?? this.DEFAULT_EMPTY
      };
      
      this.http.post<any>(this.epaycoSessionEndpoint, request).subscribe(
        (response) => {
          console.log('SessionId obtenido:', response.sessionId);
          this.sessionId = response.sessionId;
          resolve(response.sessionId);
        },
        (error) => {
          console.error('Error obteniendo sessionId:', error);
          reject(error);
        }
      );
    });
  }

  initializeEPayco() {
    console.log('epaycoComponente: ' + this.epaycoFormData);
    
    (window as any).pagar = () => {
      this.ngZone.run(async () => {
        try {
          const sessionId = await this.obtenerSessionId();
          
          const checkout = (window as any).ePayco.checkout.configure({
            sessionId: sessionId,
            type: "onpage"
          });
          
          checkout.setHooks({
            onCreated: () => {
              console.log('Checkout creado exitosamente');
            },
            onResponse: (data: any) => {
              console.log('Respuesta de pago:', data);
            },
            onErrors: (error: any) => {
              console.error('Error en checkout:', error);
            },
            onClosed: () => {
              console.log('Checkout cerrado');
            }
          });
          
          const data = {
            name: this.epaycoFormData.name,
            description: this.epaycoFormData.description,
            invoice: this.factura(),
            currency: "cop",
            amount: this.epaycoFormData.amount,
            country: "co",
            lang: "en",
            external: "true",
            extra1: this.epaycoFormData.extra1,
            extra2: this.epaycoFormData.extra2,
            extra3: this.extra3,
            confirmation: this.confirmationEnvironment,
            response: this.responseEnvironment,
            name_billing: this.epaycoFormData.name_billing,
            address_billing: this.epaycoFormData.address_billing,
            type_doc_billing: "cc",
            mobilephone_billing: this.epaycoFormData.mobilephone_billing,
            number_doc_billing: this.epaycoFormData.number_doc_billing,
            email_billing: this.epaycoFormData.email_billing
          };

          checkout.open(data);
        } catch (error) {
          console.error('Error en pagar:', error);
        }
      });
    };
  }

  pagar() {
    if (this.ePaycoLoaded) {
      (window as any).pagar();
    } else {
      console.error('ePayco aún no está cargado');
    }
  }
}